import {
  INIT_UIPPS,
  EDIT_UIPPS_STATUS,
  ADD_UIPPS_COORDS,
  CLEAR_UIPPS,
  UPDATE_SINGLE_UIPPS,
  ADD_NEW_UIPPS,
} from '../type';
import { mergeData } from '../../utils/mergeData';

export function uippsReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_UIPPS: {
      // Добавляем элементы к существующему состоянию
      return [...state, ...payload];
    }

    case CLEAR_UIPPS: {
      return payload;
    }

    case UPDATE_SINGLE_UIPPS: {
      const updatedState = state.map((uipps) => {
        if (uipps.id === Number(payload.id)) {
          return { ...uipps, ...payload };
        }
        return uipps;
      });
      return updatedState;
    }

    case ADD_NEW_UIPPS: {
      // Возвращаем новый массив с добавленным устройством
      return [payload, ...state];
    }

    case ADD_UIPPS_COORDS: {
      const updatedState = mergeData(state, payload);
      return updatedState;
    }

    case EDIT_UIPPS_STATUS: {
      const updatedUipps = state.map((uipps) => {
        if (uipps.id === Number(payload.deviceId)) {
          return { ...uipps, ...payload };
        }
        return uipps;
      });
      return updatedUipps;
    }

    default:
      return state;
  }
}
